import {
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Button from "@mui/material/Button";
import { CONTACT } from "../../config/site";

export default function PlanCard({
  title,
  desc,
  price,
  period,
  features,
  popular,
  waText,
}) {
  const wa = () => {
    const q = encodeURIComponent(waText || `أرغب بالاشتراك في: ${title}`);
    window.open(
      `https://wa.me/${CONTACT.whatsapp}?text=${q}`,
      "_blank",
      "noopener"
    );
  };
  return (
    <Paper
      variant="outlined"
      sx={{
        height: "100%",
        p: { xs: 2.5, md: 3 },
        borderRadius: 1,
        position: "relative",
        ...(popular && {
          borderColor: "primary.main",
          boxShadow: "0 12px 36px rgba(84,49,152,.18)",
        }),
      }}
    >
      {popular && (
        <Chip
          icon={<StarRoundedIcon />}
          label="الأكثر مبيعًا"
          color="warning"
          size="small"
          sx={{
            position: "absolute",
            top: 12,
            insetInlineStart: 12,
            fontWeight: 800,
            p: 2,
            borderRadius: 0.5,
          }}
        />
      )}
      <Stack spacing={1}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 900, pt: popular ? 3.5 : 0 }}
        >
          {title}
        </Typography>
        <Typography color="text.secondary">{desc}</Typography>
        <Stack
          direction="row"
          alignItems="baseline"
          spacing={1}
          sx={{ mt: 0.5 }}
        >
          <Typography variant="h4" sx={{ fontWeight: 900 }}>
            {price.toLocaleString("ar-SA")} ر.س
          </Typography>
          <Typography color="text.secondary" sx={{ fontWeight: 700 }}>
            / {period}
          </Typography>
        </Stack>
        <List dense disablePadding sx={{ mt: 1 }}>
          {features?.map((f) => (
            <ListItem key={f} sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: 34, color: "success.main" }}>
                <CheckCircleRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={f}
                primaryTypographyProps={{
                  variant: "body2",
                  sx: { lineHeight: 1.9 },
                }}
              />
            </ListItem>
          ))}
        </List>
        <Button
          fullWidth
          variant="contained"
          startIcon={<WhatsAppIcon />}
          onClick={wa}
          sx={{ fontWeight: 800 }}
        >
          اطلب الآن
        </Button>
      </Stack>
    </Paper>
  );
}
